import React from 'react'
import StandardTaskList from '../../components/standardtaskcomponents/StandardTaskList'
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const StandardTaskDetails = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Hospital Masters'));
    return <StandardTaskList />
}

export default StandardTaskDetails